import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { Role } from 'src/features/skills-matrix/skills-matrix.types';

import { SkillMatrixSegment, SkillsMatrix } from './skill-matrix-graphic.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserSkillsMatrix: builder.query<
      ApiResponse<SkillsMatrix>,
      { role: Role | undefined; segment: SkillMatrixSegment }
    >({
      query: ({ role, segment }) => ({
        method: 'GET',
        url: role ? `users/skills?role=${role}&segment=${segment}` : 'users/skills',
      }),
    }),
  }),
});

export const { useGetUserSkillsMatrixQuery } = extendedApiSlice;
